import * as React from 'react';
import { BuilderCall } from '../../components/BuilderCall';
import { useSelector } from 'react-redux';
import { selectBuilder } from '../../selectors';
import { CallButtonContainer } from '../CallButtonContainer';

export const BuilderCallContainer = () => {
  const { name, logo, url } = useSelector(selectBuilder);

  return (
    <BuilderCall
      name={name}
      logo={logo}
      url={url}
      phoneButton={<CallButtonContainer showText={false} showIcon={true} />}
    />
  );
};
